module.exports = __webpack_public_path__ + "img/dab_may.4683828a.jpg";